import Vue from 'vue'
import VueRouter from 'vue-router'
import vueg from 'vueg'
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'home',
    meta: {title: '主页'},
    redirect:'/view1',
    children: [
      {
          path: '/view1',
          name: 'view1',
          component: resolve => {
              require(['@/views/view1/index'], resolve)
          }
      },
      {
          path: '/view2',
          name: 'view2',
          component: resolve => {
              require(['@/views/view2/index'], resolve)
          }
      },
    ],
    component: resolve => {
      require(['@/views/home/index'], resolve)
    }
  },
  {
    path: '/login',
    name: 'login',
    meta: { title: '登录' },
    component: resolve => {
      require(['@/views/login'], resolve)
    }
  },
  {
    path: '/things',
    name: 'things',
    meta: { title: '巡检' },
    component: resolve => {
      require(['@/views/things/index'], resolve)
    }
  },
  {
      path: '/changePwd',
      name: 'changePwd',
      component: resolve => {
          require(['@/views/changePwd'], resolve)
      },
      meta: {title: '修改密码', keepAlive: false}
  },
  {
    path: '/yhxf',
    name: 'yhxf',
    meta: { title: '巡检下发' },
    component: resolve => {
      require(['@/views/yhxf/list'], resolve)
    }
  },
  {
    path: '/thingswh',
    name: 'thingswh',
    meta: { title: '维护' },
    component: resolve => {
      require(['@/views/thingswh/index'], resolve)
    }
  },
  {
    path: '/yhxfwh',
    name: 'yhxfwh',
    meta: { title: '维护记录' },
    component: resolve => {
      require(['@/views/yhxfwh/list'], resolve)
    }
  },
  {
    path: '/thingsby',
    name: 'thingsby',
    meta: { title: '保养' },
    component: resolve => {
      require(['@/views/thingsby/index'], resolve)
    }
  },
  {
    path: '/yhxfby',
    name: 'yhxfby',
    meta: { title: '保养记录' },
    component: resolve => {
      require(['@/views/yhxfby/list'], resolve)
    }
  },
  {
    path: '/thingsdj',
    name: 'thingsdj',
    meta: { title: '点检' },
    component: resolve => {
      require(['@/views/thingsdj/index'], resolve)
    }
  },
  {
    path: '/yhxfdj',
    name: 'yhxfdj',
    meta: { title: '点检记录' },
    component: resolve => {
      require(['@/views/yhxfdj/list'], resolve)
    }
  },
  {
    path: '/thingsgzqr',
    name: 'thingsgzqr',
    meta: { title: '报警确认' },
    component: resolve => {
      require(['@/views/thingsgzqr/index'], resolve)
    }
  },
  {
    path: '/yhxfgzqr',
    name: 'yhxfgzqr',
    meta: { title: '报警确认记录' },
    component: resolve => {
      require(['@/views/yhxfgzqr/list'], resolve)
    }
  },
  {
    path: '/thingsgzxc',
    name: 'thingsgzxc',
    meta: { title: '故障消除' },
    component: resolve => {
      require(['@/views/thingsgzxc/index'], resolve)
    }
  },
  {
    path: '/yhxfgzxc',
    name: 'yhxfgzxc',
    meta: { title: '故障消除记录' },
    component: resolve => {
      require(['@/views/yhxfgzxc/list'], resolve)
    }
  },
  {
    path: '/message',
    name: 'message',
    meta: { title: '通知消息' },
    component: resolve => {
      require(['@/views/message/list'], resolve)
    }
  },
  {
    path: '/yhzg',
    name: 'yhzg',
    meta: { title: '巡检整改' },
    component: resolve => {
      require(['@/views/yhzg/list'], resolve)
    }
  },
  {
    path: '/sbfx',
    name: 'sbfx',
    meta: { title: '设备分析' },
    component: resolve => {
      require(['@/views/sbfx/list'], resolve)
    }
  },
  {
    path: '/sbfxShow',
    name: 'sbfxShow',
    meta: { title: '设备分析' },
    component: resolve => {
      require(['@/views/sbfx/show'], resolve)
    }
  },
  {
    path: '/yqsp',
    name: 'yqsp',
    meta: { title: '巡检整改' },
    component: resolve => {
      require(['@/views/yqsp/list'], resolve)
    }
  },
  {
    path: '/zgys',
    name: 'zgys',
    meta: { title: '整改验收' },
    component: resolve => {
      require(['@/views/zgys/list'], resolve)
    }
  },
  {
    path: '/ygd',
    name: 'ygd',
    meta: { title: '已归档' },
    component: resolve => {
      require(['@/views/ygd/list'], resolve)
    }
  },
]
const router = new VueRouter({
  routes
})
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const options = {
  duration: '0.3',              //转场动画时长，默认为0.3，单位秒
  firstEntryDisable: true,     //值为true时禁用首次进入应用时的渐现动画，默认为false  
  firstEntryDuration: '.6',     //首次进入应用时的渐现动画时长，默认为.6  
  forwardAnim: 'fadeInRight',   //前进动画，默认为fadeInRight  
  backAnim: 'fadeInLeft',       //后退动画，默认为fedeInLeft  
  sameDepthDisable: false,      //url深度相同时禁用动画，默认为false  
  tabs: [{
    name: 'home'
  }, {
    name: 'my'
  }],                       //默认为[]，name对应路由的name,以实现类似app中点击tab页面水平转场效果，如tab[1]到tab[0]，会使用backAnim动画，tab[1]到tab[2]，会使用forwardAnim动画  
  tabsDisable: false,           //值为true时，tabs间的转场没有动画，默认为false  
  disable: false,               //禁用转场动画，默认为false，嵌套路由默认为true   
}
Vue.use(vueg, router, options)

export default router
